import { render, staticRenderFns } from "./CrearAlerta.vue?vue&type=template&id=5f295df0&"
import script from "./CrearAlerta.vue?vue&type=script&lang=ts&"
export * from "./CrearAlerta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5f295df0', component.options)
    } else {
      api.reload('5f295df0', component.options)
    }
    module.hot.accept("./CrearAlerta.vue?vue&type=template&id=5f295df0&", function () {
      api.rerender('5f295df0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Telemetria/FugaCombustible/CrearAlerta.vue"
export default component.exports